import axios, { AxiosError } from 'axios';
import { useAuth } from './auth-store';

export const api = axios.create({ baseURL: '/v1', timeout: 15_000 });

api.interceptors.request.use((cfg) => {
  const token = useAuth.getState().token;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      useAuth.getState().clear();
      // One sign-in surface for the whole product — see SIGN_IN_URL in App.tsx.
      const signIn = import.meta.env.VITE_SIGN_IN_URL ?? 'https://kardocloud.com/live/login/';
      if (!window.location.pathname.endsWith('/login')) window.location.href = signIn;
    }
    return Promise.reject(err);
  },
);
